var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "background-color": "#01714D"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "15px",
      "padding-top": "14px",
      "font-size": "22px",
      "color": "white",
      "font-family": "Sans-serif"
    }
  }, [_vm._v("\n\t\t\t迈亚—人力资源系统\n\t\t")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('img', {
    staticStyle: {
      "padding": "15px 30px",
      "width": "25px",
      "height": "25px"
    },
    attrs: {
      "src": require("../src/assets/退出登录.png")
    },
    on: {
      "click": function($event) {
        return _vm.signout()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('img', {
    staticStyle: {
      "padding": "15px 30px",
      "width": "25px",
      "height": "25px"
    },
    attrs: {
      "src": require("../src/assets/修改密码.png")
    },
    on: {
      "click": _vm.Uppwd
    }
  })])]), _vm._v(" "), _c('router-view', {
    staticClass: "Route",
    staticStyle: {
      "width": "86.6%",
      "float": "right",
      "background-color": "#f7f8fa",
      "min-height": "880px"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "13.7%",
      "height": "130px",
      "border-right": "1px solid #e7eaeb",
      "border-bottom": "1px solid #e7eaeb"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "20px",
      "width": "25px"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.user_name))])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "13.7%"
    }
  }, [_c('el-row', {
    staticClass: "tac",
    staticStyle: {
      "height": "750px",
      "overflow-x": "hidden"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-scrollbar', {
    staticClass: "page-scroll"
  }, [_c('el-menu', {
    staticStyle: {
      "height": "100%",
      "margin-left": "10px"
    },
    attrs: {
      "active-text-color": "#02704D"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Home')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/导航_首页.png")
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" 首页")])]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/员工档案管理.png")
    }
  }), _vm._v("  员工档案管理")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.contract == 'contract') ? _c('el-menu-item', {
    attrs: {
      "index": "2-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('HtmbGL')
      }
    }
  }, [_vm._v("模板管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.Examine == 'Examine') ? _c('el-menu-item', {
    attrs: {
      "index": "2-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('HtmbSH')
      }
    }
  }, [_vm._v("合同模板审核")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.launch == 'launch') ? _c('el-menu-item', {
    attrs: {
      "index": "2-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('HtqdFQ')
      }
    }
  }, [_vm._v("合同签订发起")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ContractSigning == 'ContractSigning') ? _c('el-menu-item', {
    attrs: {
      "index": "2-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Htqd')
      }
    }
  }, [_vm._v("合同签订")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ContractArchiving == 'ContractArchiving') ? _c('el-menu-item', {
    attrs: {
      "index": "2-5"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Htgd')
      }
    }
  }, [_vm._v("合同归档")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.profileInformation == 'profileInformation') ? _c('el-menu-item', {
    attrs: {
      "index": "2-6"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Ygdaxx')
      }
    }
  }, [_vm._v("员工档案信息")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.titleManagement == 'titleManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "2-7"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Jfmtgl')
      }
    }
  }, [_vm._v("合同名头管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.FilesProjectContract == 'FilesProjectContract') ? _c('el-menu-item', {
    attrs: {
      "index": "2-8"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Xmht')
      }
    }
  }, [_vm._v("项目合同")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/基础人事管理.png")
    }
  }), _vm._v("  基础人事管理")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.organization == 'organization') ? _c('el-menu-item', {
    attrs: {
      "index": "3-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Jtzzjg')
      }
    }
  }, [_vm._v("集团组织架构管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.EmployeeList == 'EmployeeList') ? _c('el-menu-item', {
    attrs: {
      "index": "3-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Ygxxlb')
      }
    }
  }, [_vm._v("员工信息列表")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.Induction == 'Induction') ? _c('el-menu-item', {
    attrs: {
      "index": "3-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Ygrz')
      }
    }
  }, [_vm._v("员工入职")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffContract == 'StaffContract') ? _c('el-menu-item', {
    attrs: {
      "index": "3-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Yghtqd')
      }
    }
  }, [_vm._v("员工合同签订")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffBecomeFormal == 'StaffBecomeFormal') ? _c('el-menu-item', {
    attrs: {
      "index": "3-5"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Ygzz')
      }
    }
  }, [_vm._v("员工转正")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.quit == 'quit') ? _c('el-menu-item', {
    attrs: {
      "index": "3-6"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Yglz')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t员工离职")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffTransferPost == 'StaffTransferPost') ? _c('el-menu-item', {
    attrs: {
      "index": "3-7"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Ygtg')
      }
    }
  }, [_vm._v("员工调岗")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.management == 'management') ? _c('el-menu-item', {
    attrs: {
      "index": "3-8"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Hmdgl')
      }
    }
  }, [_vm._v("黑名单管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.Insurance_base_management == 'Insurance_base_management') ? _c('el-menu-item', {
    attrs: {
      "index": "3-9"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Bxjsgl')
      }
    }
  }, [_vm._v("保险基数管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffGoOut == 'StaffGoOut') ? _c('el-menu-item', {
    attrs: {
      "index": "3-10"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Wcsq')
      }
    }
  }, [_vm._v("外出申请")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffLeave == 'StaffLeave') ? _c('el-menu-item', {
    attrs: {
      "index": "3-11"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Qjsq')
      }
    }
  }, [_vm._v("请假申请")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffTravel == 'StaffTravel') ? _c('el-menu-item', {
    attrs: {
      "index": "3-12"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Ccsq')
      }
    }
  }, [_vm._v("出差申请")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffMake == 'StaffMake') ? _c('el-menu-item', {
    attrs: {
      "index": "3-13"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Bksq')
      }
    }
  }, [_vm._v("补卡申请")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffOvertime == 'StaffOvertime') ? _c('el-menu-item', {
    attrs: {
      "index": "3-14"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Jbsq')
      }
    }
  }, [_vm._v("加班申请")]) : _vm._e(), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "3-15"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("岗位支援管理")]), _vm._v(" "), (_vm.Jurisdiction.StaffPostSupport == 'StaffPostSupport') ? _c('el-menu-item', {
    attrs: {
      "index": "3-15-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Gwzysq')
      }
    }
  }, [_vm._v("岗位支援申请")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffSupport == 'StaffSupport') ? _c('el-menu-item', {
    attrs: {
      "index": "3-15-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Gwzy')
      }
    }
  }, [_vm._v("岗位支援")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffSupportAccept == 'StaffSupportAccept') ? _c('el-menu-item', {
    attrs: {
      "index": "3-15-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Gwzyjs')
      }
    }
  }, [_vm._v("岗位支援接收")]) : _vm._e()], 2), _vm._v(" "), (_vm.Jurisdiction.StaffReplacePost == 'StaffReplacePost') ? _c('el-menu-item', {
    attrs: {
      "index": "3-16"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Dgsq')
      }
    }
  }, [_vm._v("代岗申请")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffWages == 'StaffWages') ? _c('el-menu-item', {
    attrs: {
      "index": "3-17"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Jcgl')
      }
    }
  }, [_vm._v("工资申请单")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffChangeSalary == 'StaffChangeSalary') ? _c('el-menu-item', {
    attrs: {
      "index": "3-18"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Zttx')
      }
    }
  }, [_vm._v("整体调薪")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffExamine == 'StaffExamine') ? _c('el-menu-item', {
    attrs: {
      "index": "3-19"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('QAsp')
      }
    }
  }, [_vm._v("OA审批")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/保险管理.png")
    }
  }), _vm._v("  保险管理")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.UnpaidInsurance == 'UnpaidInsurance') ? _c('el-menu-item', {
    attrs: {
      "index": "4-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Unpaid')
      }
    }
  }, [_vm._v("未缴纳保险")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.EmployerInsurance == 'EmployerInsurance') ? _c('el-menu-item', {
    attrs: {
      "index": "4-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Gzxgl')
      }
    }
  }, [_vm._v("雇主险管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.Insurance_Premium_Management == 'Insurance_Premium_Management') ? _c('el-menu-item', {
    attrs: {
      "index": "4-6"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Gzxbfgl')
      }
    }
  }, [_vm._v("雇主险保费管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.EmployerDanger == 'EmployerDanger') ? _c('el-menu-item', {
    attrs: {
      "index": "4-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Gzxcx')
      }
    }
  }, [_vm._v("雇主险出险")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.OtherRisks == 'OtherRisks') ? _c('el-menu-item', {
    attrs: {
      "index": "4-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Qtxzgl')
      }
    }
  }, [_vm._v("其他险种管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.OtherDanger == 'OtherDanger') ? _c('el-menu-item', {
    attrs: {
      "index": "4-5"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Qtxzcx')
      }
    }
  }, [_vm._v("其他险种出险")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/智能排班.png")
    }
  }), _vm._v("  智能排班")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.AttendanceGroup == 'AttendanceGroup') ? _c('el-menu-item', {
    attrs: {
      "index": "5-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('KqzGl')
      }
    }
  }, [_vm._v("考勤组管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ProjectManagement == 'ProjectManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "5-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('QyxmGl')
      }
    }
  }, [_vm._v("签约项目管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.WorkforceManagement == 'WorkforceManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "5-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('ZnPb')
      }
    }
  }, [_vm._v("排班管理")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "6"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/考勤管理.png")
    }
  }), _vm._v("  考勤管理")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.PunchDetails == 'PunchDetails') ? _c('el-menu-item', {
    attrs: {
      "index": "6-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('dkmx')
      }
    }
  }, [_vm._v("打卡明细查询")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.PunchInPhotoQuery == 'PunchInPhotoQuery') ? _c('el-menu-item', {
    attrs: {
      "index": "6-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Dkzp')
      }
    }
  }, [_vm._v("打卡照片查询")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.AttendanceSummary == 'AttendanceSummary') ? _c('el-menu-item', {
    attrs: {
      "index": "6-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('KqHz')
      }
    }
  }, [_vm._v("考勤汇总")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "10"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/工资核算管理.png")
    }
  }), _vm._v("  工资核算管理")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.SalaryDetails == 'SalaryDetails') ? _c('el-menu-item', {
    attrs: {
      "index": "10-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('GzMx')
      }
    }
  }, [_vm._v("工资明细表")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.SalaryDetailsSupplement == 'SalaryDetailsSupplement') ? _c('el-menu-item', {
    attrs: {
      "index": "10-9"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('GzmxBc')
      }
    }
  }, [_vm._v("工资明细表-补充")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.Proportion_of_Wages == 'Proportion_of_Wages') ? _c('el-menu-item', {
    attrs: {
      "index": "10-8"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('GzZb')
      }
    }
  }, [_vm._v("工资占比表")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ProportionSummary == 'ProportionSummary') ? _c('el-menu-item', {
    attrs: {
      "index": "10-10"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('GzHz')
      }
    }
  }, [_vm._v("工资汇总表")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.PayrollSummary == 'PayrollSummary') ? _c('el-menu-item', {
    attrs: {
      "index": "10-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('GzffHz')
      }
    }
  }, [_vm._v("工资发放汇总表")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.PayrollSplitSummary == 'PayrollSplitSummary') ? _c('el-menu-item', {
    attrs: {
      "index": "10-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('GzcfHz')
      }
    }
  }, [_vm._v("工资拆分汇总表")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.SalarySplitCashStatement == 'SalarySplitCashStatement') ? _c('el-menu-item', {
    attrs: {
      "index": "10-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('GzcfMx')
      }
    }
  }, [_vm._v("工资拆分明细表")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.DistributionRatioSetting == 'DistributionRatioSetting') ? _c('el-menu-item', {
    attrs: {
      "index": "10-7"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('FfblSz')
      }
    }
  }, [_vm._v("发放比率设置")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.CalculationMethod == 'CalculationMethod') ? _c('el-menu-item', {
    attrs: {
      "index": "10-11"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Jsfs')
      }
    }
  }, [_vm._v("计算方式")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "7"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/行政管理.png")
    }
  }), _vm._v("  行政管理")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.DormitoryRoomManagement == 'DormitoryRoomManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "7-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('SsfjGl')
      }
    }
  }, [_vm._v("宿舍房间管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.DormitoryOccupancyManagement == 'DormitoryOccupancyManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "7-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('SsrzGl')
      }
    }
  }, [_vm._v("宿舍入住管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.DormitoryCheckManagement == 'DormitoryCheckManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "7-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('SstzGl')
      }
    }
  }, [_vm._v("宿舍退住管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.LtemManagement == 'LtemManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "7-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('WpGl')
      }
    }
  }, [_vm._v("物品管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.LtemLendingManagement == 'LtemLendingManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "7-5"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('WpjcGl')
      }
    }
  }, [_vm._v("物品借出管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.LtemReturnManagement == 'LtemReturnManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "7-6"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('WpghGl')
      }
    }
  }, [_vm._v("物品归还管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.LtemComprehensiveQuery == 'LtemComprehensiveQuery') ? _c('el-menu-item', {
    attrs: {
      "index": "7-7"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('WpzhCx')
      }
    }
  }, [_vm._v("物品综合查询")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "12"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/导航-投标管理-绿.png")
    }
  }), _vm._v("  投标管理")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.BidMargin == 'BidMargin') ? _c('el-menu-item', {
    attrs: {
      "index": "12-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Bond')
      }
    }
  }, [_vm._v("保证金管理")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.BidPerformanceBond == 'BidPerformanceBond') ? _c('el-menu-item', {
    attrs: {
      "index": "12-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Performance')
      }
    }
  }, [_vm._v("履约金管理")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.BidPerformanceAnalysis == 'BidPerformanceAnalysis') ? _c('el-menu-item', {
    attrs: {
      "index": "12-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Agreement')
      }
    }
  }, [_vm._v("履约分析表")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.BidSummary == 'BidSummary') ? _c('el-menu-item', {
    attrs: {
      "index": "12-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Gather')
      }
    }
  }, [_vm._v("投标汇总表")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "14"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/系统管理.png")
    }
  }), _vm._v("  应收帐款管理")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.AccountsReceivableManage == 'AccountsReceivableManage') ? _c('el-menu-item', {
    attrs: {
      "index": "14-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Receivable')
      }
    }
  }, [_vm._v("应收帐款管理")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.AccountsCollectionPlan == 'AccountsCollectionPlan') ? _c('el-menu-item', {
    attrs: {
      "index": "14-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Collection')
      }
    }
  }, [_vm._v("回款计划管理")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.AccountsRegistration == 'AccountsRegistration') ? _c('el-menu-item', {
    attrs: {
      "index": "14-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Invoicebill')
      }
    }
  }, [_vm._v("发票登记管理")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.AccountsAccountsReceivableCleaning == 'AccountsAccountsReceivableCleaning') ? _c('el-menu-item', {
    attrs: {
      "index": "14-6"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Cleaning')
      }
    }
  }, [_vm._v("保洁应收账款表")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.AccountsAccountsReceivableSecurity == 'AccountsAccountsReceivableSecurity') ? _c('el-menu-item', {
    attrs: {
      "index": "14-5"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Securitystaff')
      }
    }
  }, [_vm._v("保安应收账款表")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.AccountsDataAnalysis == 'AccountsDataAnalysis') ? _c('el-menu-item', {
    attrs: {
      "index": "14-8"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Collectiondata')
      }
    }
  }, [_vm._v("回款数据分析表")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.AccountsDetail == 'AccountsDetail') ? _c('el-menu-item', {
    attrs: {
      "index": "14-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('DetailspartyA')
      }
    }
  }, [_vm._v("甲方欠款系列明细表")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.AccountsSummary == 'AccountsSummary') ? _c('el-menu-item', {
    attrs: {
      "index": "14-7"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('DetailsparB')
      }
    }
  }, [_vm._v("甲方欠款系列汇总表")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "15"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/预算管理_未选中.png")
    }
  }), _vm._v("  预算管理")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.BudgetOrganization == 'BudgetOrganization') ? _c('el-menu-item', {
    attrs: {
      "index": "15-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Budgeting')
      }
    }
  }, [_vm._v("预算编制")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.BudgetSummary == 'BudgetSummary') ? _c('el-menu-item', {
    attrs: {
      "index": "15-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Summary')
      }
    }
  }, [_vm._v("预算汇总查询表")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.BudgetManage == 'BudgetManage') ? _c('el-menu-item', {
    attrs: {
      "index": "15-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Budmanagement')
      }
    }
  }, [_vm._v("预算管理")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.BudgetSplit == 'BudgetSplit') ? _c('el-menu-item', {
    attrs: {
      "index": "15-5"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Budsplitting')
      }
    }
  }, [_vm._v("预算拆分")]) : _vm._e()], 1)], 2), _vm._v(" "), (_vm.Jurisdiction.MobilizationMeasurementMmanage == 'MobilizationMeasurementMmanage') ? _c('el-menu-item', {
    attrs: {
      "index": "16"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Mobilization')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/进场测算管理_未选中.png")
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" 进场测算管理")])]) : _vm._e(), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "13"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/系统管理.png")
    }
  }), _vm._v("  OA管理")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.OaSetup == 'OaSetup') ? _c('el-menu-item', {
    attrs: {
      "index": "13-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('approve')
      }
    }
  }, [_vm._v("OA审批")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.OaExamineApprove == 'OaExamineApprove') ? _c('el-menu-item', {
    attrs: {
      "index": "13-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('set')
      }
    }
  }, [_vm._v("OA设置")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "8"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/系统管理.png")
    }
  }), _vm._v("  系统管理")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.UserManagement == 'UserManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "8-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('user')
      }
    }
  }, [_vm._v("用户管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.RoleManagement == 'RoleManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "8-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('role')
      }
    }
  }, [_vm._v("角色管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.PostManagement == 'PostManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "8-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('post')
      }
    }
  }, [_vm._v("岗位管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ApprovalProcessManagement == 'ApprovalProcessManagement') ? _c('el-menu-item', {
    attrs: {
      "index": "8-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('flow')
      }
    }
  }, [_vm._v("审批流管理")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.AdministratorControl == 'AdministratorControl') ? _c('el-menu-item', {
    attrs: {
      "index": "8-5"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('setter')
      }
    }
  }, [_vm._v("管理员设置")]) : _vm._e()], 1)], 2), _vm._v(" "), (_vm.Jurisdiction.DataDictionary == 'DataDictionary') ? _c('el-submenu', {
    attrs: {
      "index": "9"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/数据字典.png")
    }
  }), _vm._v("  数据字典")]), _vm._v(" "), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "9-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('first_degree')
      }
    }
  }, [_vm._v("第一学历")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('second_degree')
      }
    }
  }, [_vm._v("最高学历")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('entry_type')
      }
    }
  }, [_vm._v("入职类型")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('recruitment_method')
      }
    }
  }, [_vm._v("招聘方式\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-5"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('health')
      }
    }
  }, [_vm._v("健康状况")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-6"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('household_register')
      }
    }
  }, [_vm._v("户籍性质\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-7"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('staff_type')
      }
    }
  }, [_vm._v("员工类别")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-8"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('insurance_type')
      }
    }
  }, [_vm._v("投保类别")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-9"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('underwriting_type')
      }
    }
  }, [_vm._v("承保公司")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-10"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('room_type')
      }
    }
  }, [_vm._v("房间类别")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-11"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('article_type')
      }
    }
  }, [_vm._v("物品类别")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-14"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('bank')
      }
    }
  }, [_vm._v("银行")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-15"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('resignation_reason')
      }
    }
  }, [_vm._v("离职原因\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-16"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('leave_type')
      }
    }
  }, [_vm._v("请假类型")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-17"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('errand_type')
      }
    }
  }, [_vm._v("出差方式")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-18"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('contract_type')
      }
    }
  }, [_vm._v("合同类别")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-19"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('bonus_penalty')
      }
    }
  }, [_vm._v("奖惩类别")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-20"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('change_salary')
      }
    }
  }, [_vm._v("调薪类型")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-21"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('age_group')
      }
    }
  }, [_vm._v("年龄段类型")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-22"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('traffic_vehicle')
      }
    }
  }, [_vm._v("交通工具")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-23"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('agency_company')
      }
    }
  }, [_vm._v("代发公司")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-24"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('split_account')
      }
    }
  }, [_vm._v("拆分账户")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-25"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('business_sector')
      }
    }
  }, [_vm._v("业务板块")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-26"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('business_series')
      }
    }
  }, [_vm._v("业务系列")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-27"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('material')
      }
    }
  }, [_vm._v("物料表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-28"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('fixedassets')
      }
    }
  }, [_vm._v("固定资产表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "9-29"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('integration')
      }
    }
  }, [_vm._v("集成字段")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "11"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../src/assets/系统管理.png")
    }
  }), _vm._v("  报表中心")]), _vm._v(" "), _c('el-menu-item-group', [(_vm.Jurisdiction.ReportEntryResignation == 'ReportEntryResignation') ? _c('el-menu-item', {
    attrs: {
      "index": "11-1"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('entry_exit')
      }
    }
  }, [_vm._v("入离职报表")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.StaffBasicInformation == 'StaffBasicInformation') ? _c('el-menu-item', {
    attrs: {
      "index": "11-2"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('employee_info')
      }
    }
  }, [_vm._v("员工基本信息")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ReportFiveInsuranceStatistics == 'ReportFiveInsuranceStatistics') ? _c('el-menu-item', {
    attrs: {
      "index": "11-3"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('five_insurances_statistical')
      }
    }
  }, [_vm._v("五险统计表\n\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ReportFiveInsuranceDetail == 'ReportFiveInsuranceDetail') ? _c('el-menu-item', {
    attrs: {
      "index": "11-4"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('five_insurances_detailed')
      }
    }
  }, [_vm._v("五险明细表\n\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ReportInsuranceSettlement == 'ReportInsuranceSettlement') ? _c('el-menu-item', {
    attrs: {
      "index": "11-5"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('employer_insurance')
      }
    }
  }, [_vm._v("雇主险费用及理赔\n\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ReportInsuranceStatistics == 'ReportInsuranceStatistics') ? _c('el-menu-item', {
    attrs: {
      "index": "11-6"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('employer_insurance_statistical')
      }
    }
  }, [_vm._v("雇主险电动车统计\n\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ReportOtherRisks == 'ReportOtherRisks') ? _c('el-menu-item', {
    attrs: {
      "index": "11-7"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('electric_vehicle_insurance')
      }
    }
  }, [_vm._v("电动车险费用及理赔\n\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ProjectAddressBook == 'ProjectAddressBook') ? _c('el-menu-item', {
    attrs: {
      "index": "11-8"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('project_address_book')
      }
    }
  }, [_vm._v("项目通讯录\n\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ReportProjectCondition == 'ReportProjectCondition') ? _c('el-menu-item', {
    attrs: {
      "index": "11-9"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('project_natural_conditions')
      }
    }
  }, [_vm._v("项目自然情况表\n\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ReportProjectAssessment == 'ReportProjectAssessment') ? _c('el-menu-item', {
    attrs: {
      "index": "11-10"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('project_assessment')
      }
    }
  }, [_vm._v("项目考核表")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.ReportBigRanking == 'ReportBigRanking') ? _c('el-menu-item', {
    attrs: {
      "index": "11-11"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('big_ranking')
      }
    }
  }, [_vm._v("大排名")]) : _vm._e(), _vm._v(" "), (_vm.Jurisdiction.BudgetComparison == 'BudgetComparison') ? _c('el-menu-item', {
    attrs: {
      "index": "11-12"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('budget_comparison_table')
      }
    }
  }, [_vm._v("预算对比报表")]) : _vm._e()], 1)], 2)], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "close-on-click-modal": false,
      "center": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "from",
    staticStyle: {
      "padding": "0 10%"
    },
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原密码",
      "prop": "oldPwd"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入原密码"
    },
    model: {
      value: (_vm.from.oldPwd),
      callback: function($$v) {
        _vm.$set(_vm.from, "oldPwd", $$v)
      },
      expression: "from.oldPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newPwd"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.from.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.from, "newPwd", $$v)
      },
      expression: "from.newPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "newPwdS"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请再次输入新密码"
    },
    model: {
      value: (_vm.from.newPwdS),
      callback: function($$v) {
        _vm.$set(_vm.from, "newPwdS", $$v)
      },
      expression: "from.newPwdS"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "30%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Update
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0px auto",
      "width": "70px",
      "height": "70px",
      "border-radius": "35px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("../src/assets/用户头像.png")
    }
  })])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e2b1795","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Main.vue
// module id = null
// module chunks = 